export default __webpack_public_path__ + "static/media/blog-img144.83638475.jpg";